
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/books/[isbn]",
      function () {
        return require("private-next-pages/admin/books/[isbn].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/books/[isbn]"])
      });
    }
  